var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 16.3V5.1H14.2v11.2H5.3V37h8.8v6.5h20.7V37h8.8V16.3h-8.8zM16 6.9h17v9.4H16V6.9zm17 34.7H16V29.3h17v12.3zm8.8-6.5h-7v-7.7H14.2v7.7h-7v-17h34.7v17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20.4h2.4v1.8H34zM37.5 20.4h2.4v1.8h-2.4zM18.6 32.2h11.8V34H18.6zM18.6 36.9h11.8v1.8H18.6z"
  })));
};
export default SvgPrint;